let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}

/* ============================================================
   ARAB — Transparent hero header (homepage only)
   Self-contained: injects its own CSS, overlays the header on
   the hero, white content at top, solid cream after scroll,
   and disables the old (video-based) transparency logic.
   ============================================================ */
(function () {
  function isHome() {
    var p = location.pathname.replace(/\/+$/, '');
    return p === '' || p === '/ar' || p === '/en';
  }

  function injectCSS() {
    if (document.getElementById('arab-hdr-css')) return;
    var st = document.createElement('style');
    st.id = 'arab-hdr-css';
    st.textContent =
      '.header-wrapper{transition:background-color .35s ease,box-shadow .35s ease,border-color .35s ease;}' +
      '#MainContent > .shopify-section:first-child{margin-top:calc(-1 * var(--header-height,100px));}' +
      'html body .header-wrapper.arab-clear,html body .header-wrapper.arab-clear.gradient,html body .header-wrapper.arab-clear .header{background:transparent!important;background-color:transparent!important;box-shadow:none!important;border-bottom-color:transparent!important;}' +
      'html body .header-wrapper.arab-clear .header{border-bottom:0!important;}' +
      'html body .header-wrapper.arab-clear a,html body .header-wrapper.arab-clear button,html body .header-wrapper.arab-clear .header__icon,html body .header-wrapper.arab-clear .header__menu-item,html body .header-wrapper.arab-clear .header__active-menu-item,html body .header-wrapper.arab-clear svg,html body .header-wrapper.arab-clear .header__heading-link,html body .header-wrapper.arab-clear .arab-lang-text{color:#fff!important;fill:#fff!important;}' +
      'html body .header-wrapper.arab-clear .arab-lang-btn{border-color:rgba(255,255,255,.55)!important;}' +
      'html body .header-wrapper.arab-clear .header__heading-logo{filter:brightness(0) invert(1)!important;}';
    document.head.appendChild(st);
  }

  function init() {
    var wrap = document.querySelector('.header-wrapper');
    var hero = document.querySelector('#MainContent > .shopify-section');
    if (!wrap || !hero || !isHome()) return;
    injectCSS();

    function headerH() {
      var h = document.querySelector('.header');
      return h ? h.offsetHeight : 100;
    }
    function setVar() {
      document.documentElement.style.setProperty('--header-height', headerH() + 'px');
    }
    function check() {
      wrap.classList.remove('header-transparent'); /* disable legacy video-based logic */
      if (hero.getBoundingClientRect().bottom > headerH() + 10) {
        wrap.classList.add('arab-clear');
      } else {
        wrap.classList.remove('arab-clear');
      }
    }

    setVar();
    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', function () { setVar(); check(); }, { passive: true });
    window.addEventListener('load', function () { setVar(); check(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   ARAB — Lazy-load videos (PERFORMANCE)
   The old theme code force-loaded EVERY <deferred-media> video
   immediately on page load (~10MB each, twice => ~20MB, the #1
   cause of the slow mobile LCP). This runs FIRST (deferred, before
   DOMContentLoaded), removes each <template> so the old autoplay
   handler finds nothing to load, then loads + autoplays each video
   muted ONLY when it scrolls near the viewport.
   ============================================================ */
(function () {
  function loadDeferred(dm) {
    if (dm.__arabLoaded) return;
    dm.__arabLoaded = true;
    var html = dm.__arabTpl;
    if (!html) return;
    var holder = document.createElement('div');
    holder.innerHTML = html;
    dm.appendChild(holder);
    dm.querySelectorAll('video').forEach(function (v) {
      v.muted = true;
      v.loop = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('preload', 'auto');
      v.removeAttribute('controls');
      v.autoplay = true;
      try { v.load(); } catch (e) {}
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
    var poster = dm.querySelector('.deferred-media__poster-button');
    if (poster) poster.style.display = 'none';
  }

  function setup() {
    var list = document.querySelectorAll('deferred-media');
    if (!list.length) return;

    var io = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              loadDeferred(en.target);
              io.unobserve(en.target);
            }
          });
        }, { rootMargin: '400px 0px' })
      : null;

    list.forEach(function (dm) {
      var tpl = dm.querySelector('template');
      if (tpl) {
        dm.__arabTpl = tpl.innerHTML; /* stash markup */
        tpl.remove();                 /* remove so legacy autoplay finds nothing */
      }
      if (io) {
        io.observe(dm);
      } else {
        loadDeferred(dm); /* no IO support: just load */
      }
    });
  }

  /* Run immediately: deferred scripts execute after the DOM is parsed
     but BEFORE DOMContentLoaded, so we strip templates before the old
     handler (which runs on DOMContentLoaded) can fetch the videos. */
  if (document.readyState === 'loading') {
    /* extremely early — wait until DOM is interactive, still before DCL handlers below us are queued */
    document.addEventListener('readystatechange', function onRS() {
      if (document.readyState !== 'loading') {
        document.removeEventListener('readystatechange', onRS);
        setup();
      }
    });
  } else {
    setup();
  }
})();